var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5639 12.2787H47.7664V35.0014H44.5639V12.2787ZM38.0063 35.0014V12.2787H41.2851V35.0014H38.0063ZM33.1263 12.2787C33.5838 12.2787 33.9777 12.4312 34.3082 12.7362C34.6386 13.0412 34.8038 13.4225 34.8038 13.88V33.4001C34.8038 33.8576 34.6386 34.2389 34.3082 34.5439C33.9777 34.8489 33.5838 35.0014 33.1263 35.0014H13.6061C13.1995 35.0014 12.8309 34.8489 12.5005 34.5439C12.1701 34.2389 12.0049 33.8576 12.0049 33.4001V13.88C12.0049 13.4225 12.1701 13.0412 12.5005 12.7362C12.8309 12.4312 13.1995 12.2787 13.6061 12.2787H33.1263ZM23.3662 16.7013C22.3495 16.7013 21.4854 17.0571 20.7737 17.7688C20.062 18.4804 19.7062 19.3446 19.7062 20.3613C19.7062 21.378 20.062 22.2421 20.7737 22.9538C21.4854 23.6655 22.3495 24.0213 23.3662 24.0213C24.3829 24.0213 25.2471 23.6655 25.9587 22.9538C26.6704 22.2421 27.0262 21.378 27.0262 20.3613C27.0262 19.3446 26.6704 18.4804 25.9587 17.7688C25.2471 17.0571 24.3829 16.7013 23.3662 16.7013ZM30.6863 31.7989V30.5789C30.6863 29.4605 29.8475 28.5709 28.17 27.9101C26.4925 27.2493 24.8912 26.9188 23.3662 26.9188C21.8412 26.9188 20.2399 27.2493 18.5624 27.9101C16.8849 28.5709 16.0462 29.4605 16.0462 30.5789V31.7989H30.6863Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAccounts);
export default __webpack_public_path__ + "static/media/all-accounts.f598c3c224fb2fb183248b4a2c4fd5b6.svg";
export { ForwardRef as ReactComponent };